import React from 'react'
import HighlightsCarousel from './HighlightsCarousel';
import FAQs from './FAQs';
import Reviews from './Reviews';


const WhyACComponent = () => {
  return (
    <section className="mx-4 md:mx-24 bg-white py-8 md:py-20 px-8 md:px-16 rounded-3xl mt-4 md:mt-16">
    <h2 className="text-2xl md:text-3xl font-bold font-inter text-acBlack mb-4">Why Choose Alveria Claim?</h2>
    <p className="text-md text-acGray font-light mb-8">At Alveria Claim, we recognize how devastating financial fraud can be. Losing money to scams can take a significant toll, and we believe that victims deserve honest, ethical support. That’s why we operate with full transparency, charge fair fees, and guide you through every step of the recovery process.</p>

    <HighlightsCarousel/>
    <Reviews/>
    <FAQs/>
  </section>
  )
}

export default WhyACComponent